<template>
  <div class="contact-page">
    <div class="contact-page-title">Vamos conversar!</div>

    <div class="email-container">
      <v-img
        :src="require('@/assets/send.png')"
        height="20px"
        width="20px"
        class="mr-2"
      ></v-img>
      <div class="content-title">juliocesar.dev.system@gmail.com</div>
    </div>

    <div class="linkedin-container">
      <a
        href="https://www.linkedin.com/in/j%C3%BAlio-c%C3%A9sar-b544a1215/"
        target="_blank"
        class="linkedin-link"
      >
        <v-img
          :src="require('@/assets/linkedin.png')"
          height="20px"
          width="20px"
          class="mr-2"
        ></v-img>
        <div class="linkedin-container-title">LinkedIn</div>
      </a>
    </div>

    <div class="github-container">
      <a href="https://github.com/jces4rrr" target="_blank" class="github-link">
        <v-img
          :src="require('@/assets/github.png')"
          height="20px"
          width="20px"
          class="mr-2"
        ></v-img>
        <div class="github-container-title">Github</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",

  components: {},
};
</script>

<style src="./style.scss" lang="scss" scoped />
